/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AssetManagementListResponse } from '../../models/asset-management-list-response';
import { BaseResponse } from '../../models/base-response';

export interface AssetManagementControllerGetAll$Params {

/**
 * Sends 0 to remove limit
 */
  limit: number;
  skip: number;
  bool_temporary?: boolean;

/**
 * true: solo i seriali in riparazione presso il fornitore (casa madre); false: esclude quei seriali
 */
  repair_on_center?: boolean;
  replacement_for?: boolean;
  not_replacement_for?: boolean;
  replaced_by?: boolean;
  not_replaced_by?: boolean;
  bool_permanent?: boolean;
  asset_assigned?: boolean;

/**
 * true: i flag di stato indicati (lost, faulty, bool_temporary, repair_on_center, bool_permanent, asset_assigned) sono combinati in OR tra loro; altrimenti in AND. active resta sempre in AND
 */
  flags_or?: boolean;

/**
 * true: se è indicato serial_number, restituisce quell'asset e i correlati ignorando tutti gli altri filtri (resta solo lo scope sulle commesse dell'utente)
 */
  serial_overrides_filters?: boolean;
  show_only_asset_with_warehouse_id?: boolean;
  show_only_asset_without_warehouse_id?: boolean;
  show_only_asset_with_registry_end_customer_id?: boolean;
  show_only_asset_without_registry_end_customer_id?: boolean;
  purpose?: number;
  product_name?: string;
  registry_end_customer_id?: number;
  registry_end_customer_contact_id?: number;
  registry_end_customer_name?: string;
  registry_end_customer_country_iso?: string;
  registry_end_customer_italy_region_id?: number;
  registry_end_customer_italy_province_id?: number;
  registry_end_customer_italy_city_id?: number;
  registry_end_customer_address?: string;
  registry_end_customer_zip_code?: string;
  registry_end_customer_contact_last_name?: string;
  registry_end_customer_contact_first_name?: string;
  registry_end_customer_contact_building?: string;
  registry_end_customer_contact_floor?: string;
  registry_end_customer_contact_directions?: string;
  registry_end_customer_contact_room?: string;
  serial_number?: string;
  serial_numbers?: Array<string>;
  related_product_id?: number;
  related_customer_order_id?: number;
  related_ddt_id?: number;
  related_delivery_id?: number;
  asset_code?: string;
  inventory_code?: string;
  related_agreement_id?: number;
  related_agreement_ids?: Array<number>;
  notes?: string;
  part_number?: string;
  active?: boolean;
  lost?: boolean;
  faulty?: boolean;
  exclude_id?: number;
  related_warehouse_id?: number;

/**
 * Solo asset che si trovano nelle sedi di sistema di questo tipo (guasti, RAEE o smarriti). Insieme a related_warehouse_id, quest’ultimo è il magazzino padre della sede
 */
  warehouse_special_function?: 'GUASTI' | 'RAEE' | 'SMARRITI';
  office?: string;
  office_code?: string;
  testing_date_from?: string;
  testing_date_to?: string;
  end_of_warranty_date_from?: string;
  end_of_warranty_date_to?: string;
  end_of_vendor_warranty_date_from?: string;
  end_of_vendor_warranty_date_to?: string;
  order_by?: string;
  order_direction?: string;
}

export function assetManagementControllerGetAll(http: HttpClient, rootUrl: string, params: AssetManagementControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, assetManagementControllerGetAll.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('bool_temporary', params.bool_temporary, {});
    rb.query('repair_on_center', params.repair_on_center, {});
    rb.query('replacement_for', params.replacement_for, {});
    rb.query('not_replacement_for', params.not_replacement_for, {});
    rb.query('replaced_by', params.replaced_by, {});
    rb.query('not_replaced_by', params.not_replaced_by, {});
    rb.query('bool_permanent', params.bool_permanent, {});
    rb.query('asset_assigned', params.asset_assigned, {});
    rb.query('flags_or', params.flags_or, {});
    rb.query('serial_overrides_filters', params.serial_overrides_filters, {});
    rb.query('show_only_asset_with_warehouse_id', params.show_only_asset_with_warehouse_id, {});
    rb.query('show_only_asset_without_warehouse_id', params.show_only_asset_without_warehouse_id, {});
    rb.query('show_only_asset_with_registry_end_customer_id', params.show_only_asset_with_registry_end_customer_id, {});
    rb.query('show_only_asset_without_registry_end_customer_id', params.show_only_asset_without_registry_end_customer_id, {});
    rb.query('purpose', params.purpose, {});
    rb.query('product_name', params.product_name, {});
    rb.query('registry_end_customer_id', params.registry_end_customer_id, {});
    rb.query('registry_end_customer_contact_id', params.registry_end_customer_contact_id, {});
    rb.query('registry_end_customer_name', params.registry_end_customer_name, {});
    rb.query('registry_end_customer_country_iso', params.registry_end_customer_country_iso, {});
    rb.query('registry_end_customer_italy_region_id', params.registry_end_customer_italy_region_id, {});
    rb.query('registry_end_customer_italy_province_id', params.registry_end_customer_italy_province_id, {});
    rb.query('registry_end_customer_italy_city_id', params.registry_end_customer_italy_city_id, {});
    rb.query('registry_end_customer_address', params.registry_end_customer_address, {});
    rb.query('registry_end_customer_zip_code', params.registry_end_customer_zip_code, {});
    rb.query('registry_end_customer_contact_last_name', params.registry_end_customer_contact_last_name, {});
    rb.query('registry_end_customer_contact_first_name', params.registry_end_customer_contact_first_name, {});
    rb.query('registry_end_customer_contact_building', params.registry_end_customer_contact_building, {});
    rb.query('registry_end_customer_contact_floor', params.registry_end_customer_contact_floor, {});
    rb.query('registry_end_customer_contact_directions', params.registry_end_customer_contact_directions, {});
    rb.query('registry_end_customer_contact_room', params.registry_end_customer_contact_room, {});
    rb.query('serial_number', params.serial_number, {});
    rb.query('serial_numbers', params.serial_numbers, {});
    rb.query('related_product_id', params.related_product_id, {});
    rb.query('related_customer_order_id', params.related_customer_order_id, {});
    rb.query('related_ddt_id', params.related_ddt_id, {});
    rb.query('related_delivery_id', params.related_delivery_id, {});
    rb.query('asset_code', params.asset_code, {});
    rb.query('inventory_code', params.inventory_code, {});
    rb.query('related_agreement_id', params.related_agreement_id, {});
    rb.query('related_agreement_ids', params.related_agreement_ids, {});
    rb.query('notes', params.notes, {});
    rb.query('part_number', params.part_number, {});
    rb.query('active', params.active, {});
    rb.query('lost', params.lost, {});
    rb.query('faulty', params.faulty, {});
    rb.query('exclude_id', params.exclude_id, {});
    rb.query('related_warehouse_id', params.related_warehouse_id, {});
    rb.query('warehouse_special_function', params.warehouse_special_function, {});
    rb.query('office', params.office, {});
    rb.query('office_code', params.office_code, {});
    rb.query('testing_date_from', params.testing_date_from, {});
    rb.query('testing_date_to', params.testing_date_to, {});
    rb.query('end_of_warranty_date_from', params.end_of_warranty_date_from, {});
    rb.query('end_of_warranty_date_to', params.end_of_warranty_date_to, {});
    rb.query('end_of_vendor_warranty_date_from', params.end_of_vendor_warranty_date_from, {});
    rb.query('end_of_vendor_warranty_date_to', params.end_of_vendor_warranty_date_to, {});
    rb.query('order_by', params.order_by, {});
    rb.query('order_direction', params.order_direction, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: AssetManagementListResponse;
      }>;
    })
  );
}

assetManagementControllerGetAll.PATH = '/asset-management';
